import { useRef } from 'react';

/**
 * @description 判断当前组件是否已经挂载
 * @example const isMounted = useIsMounted()
 * @returns {boolean}
 * @author liuchuan
 */
export const useIsMounted = () => {
  const isMountedRef = useRef(false);
  const isMounted = isMountedRef.current;

  isMountedRef.current = true;

  return isMounted;
};
